import classNames from 'classnames';
import Subnav from 'components/Subnav';
import DottedSpeechBubbleIcon from 'icons/DottedSpeechBubble.icon';
import MessageIcon from 'icons/Message.icon';
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';
import { Button } from 'ncoded-component-library';
import ChatIcon from 'icons/Chat.icon';
import useMatchMedia from 'hooks/useMatchMedia';
import { QUESTIONS_ROUTES } from './data';
import SettingsIcon from 'icons/Settings.icon';
import { MOBILE_QA_SELECTOR } from '../../providers/Onboarding/data';

import './Questions.styles.scss';

const QAndARouter: React.FC = () => {
  const classes = classNames('questions', 'page');

  const { t } = useTranslation();

  const {
    canBuyerAskQuestion,
    doesUserHaveAccessToQa,
    canAccessQaSettings,
    openBuyQaDrawer,
  } = useContext(DataRoomContext);

  const { pathname } = useLocation();

  const isPhablet = useMatchMedia('isPhablet');

  const isOnFaq = pathname?.includes(QUESTIONS_ROUTES.FAQ);

  const haveAskQuestion = useMemo(
    () => isPhablet && !isOnFaq && canBuyerAskQuestion,
    [canBuyerAskQuestion, isOnFaq, isPhablet],
  );

  const title = useMemo(
    () => (doesUserHaveAccessToQa ? t('questions') : t('faqHeading')),
    [doesUserHaveAccessToQa, t],
  );

  const links = useMemo(
    () => [
      {
        to: QUESTIONS_ROUTES.Q_AND_A,
        label: t('qAndA'),
        id: MOBILE_QA_SELECTOR,
        Icon: MessageIcon,
      },
      {
        to: QUESTIONS_ROUTES.FAQ,
        label: t('faqs'),
        Icon: DottedSpeechBubbleIcon,
      },
      ...(canAccessQaSettings
        ? [
            {
              to: QUESTIONS_ROUTES.Q_AND_A_SETTINGS,
              label: t('qaSettings'),
              Icon: SettingsIcon,
            },
          ]
        : []),
    ],
    [canAccessQaSettings, t],
  );

  return (
    <div className={classes}>
      <div className="questions-and-answers__header">
        <h2>{title}</h2>
        {haveAskQuestion && (
          <Button onClick={openBuyQaDrawer} icon={ChatIcon}>
            {t('ask')}
          </Button>
        )}
      </div>

      {doesUserHaveAccessToQa && <Subnav links={links} />}
      <Outlet />
    </div>
  );
};

export default QAndARouter;
